import {shapeComponent, ShapeComponent} from "set-state-compare/build/shape-component.js"
import useDestroyedEvent from "@kaspernj/api-maker/build/use-destroyed-event.js"

const PropTypes = require("prop-types")
const propTypesExact = require("prop-types-exact")

class EventDestroyed extends ShapeComponent {
  static propTypes = propTypesExact({
    model: PropTypes.object.isRequired,
    onDestroyed: PropTypes.func.isRequired
  })

  setup() {
    const {model, onDestroyed} = this.p

    // ShapeComponent's setup() is a documented React hook location
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useDestroyedEvent(model, onDestroyed)
  }

  render() {
    return null
  }
}

export default React.memo(shapeComponent(EventDestroyed))
